import { useMemo } from 'react';
import type { IntermodalRoute } from '../../gql/graphql';
import { transformIntermodalRouteToDropdownOption } from '../../use-cases/intermodal/utils/detailsUtils';
import { useAllIntermodalRoutes } from './useAllIntermodalRoutes';

export interface IntermodalRouteDropdownOption
  extends Pick<IntermodalRoute, 'longDescription' | 'id'> {}

export const useAllIntermodalRoutesAsOptions = () => {
  const { allIntermodalRoutes, error } = useAllIntermodalRoutes();

  const intermodalRouteOptions = useMemo(() => {
    return allIntermodalRoutes.map(route => transformIntermodalRouteToDropdownOption(route));
  }, [allIntermodalRoutes]);
  return { intermodalRouteOptions, error };
};
